export default "__VITE_ASSET__BtsS3JB$__"